import React from "react";
import CustomTable from "../../helpers/customtable";
import "../../../css/UsersTable.css";

export default function UsersList({ users, t, onUserClick, loading = false }) {
  const column = (key, header, width, align = "left") => ({
    key,
    header: t(header),
    shortHeader: t(`usersHeaderShort_${header}`),
    width,
    align,
    default: t("none"),
  });
  const config = {
    rowKey: "userId",
    emptyText: t("usersTableEmpty"),
    pageSize: 10,
    showPageSizeSelector: true,
    pageSizeOptions: [10, 25, 50, 100],
    showTotalCount: true,
    labels: { filter: t("filter"), search: t("search") },
    columns: [
      column("userId", "id", "8%"),
      { ...column("name", "name", "18%"), fixed: true },
      column("email", "email", "20%"),
      column("username", "username", "14%"),
      column("sold", "balance", "10%", "right"),
      column("telephone", "phone", "12%"),
      column("address", "address", "18%"),
    ],
    onRowClick: (user) => onUserClick(user.userId),
  };

  return <div className="users-table"><CustomTable data={users} config={config} loading={loading} /></div>;
}
